import type { FeedbackDoc } from '@bb/domain/dist/schemas';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

export type SubmitFeedbackOptions = {
  dashboardId: string;
  appointmentId: string;
  feedback: Pick<FeedbackDoc, 'template'> & { id?: string };
};

const submitFeedback = async ({
  dashboardId,
  appointmentId,
  feedback,
}: SubmitFeedbackOptions) => {
  const config: AxiosRequestConfig = {
    url: `/external/dash/${dashboardId}/feedback/${appointmentId}`,
    method: 'post',
    data: { feedback },
  };

  await axios.request<void>(config);
};

export default submitFeedback;
